module.exports = __webpack_public_path__ + "img/zhengshu4.fd38b807.png";